import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import { States } from '../../features/PpsiContainer/constants';
import { ppiPublishedRoute } from '../../routes';
import { getPpiById } from '../../features/PpiContainer/selectors';

const PublishedInstructionLink = ({ data, visible = true }) => {
  const { ppiId } = data;
  const ppi = useSelector(getPpiById(ppiId));
  const publishedStatus =
    ppi && ppi.getIn(['publishedPPIEnrichmentData', 'enrichmentStatus']);
  if (!publishedStatus || !visible) {
    return null;
  }
  const linkText =
    publishedStatus === States.PUBLISHED
      ? 'Published instruction'
      : 'Unpublished instruction';
  return (
    <Typography variant="body2">
      <Link
        component={RouterLink}
        to={ppiPublishedRoute(ppiId)}
        color="secondary"
      >
        {linkText}
      </Link>{' '}
      exists
    </Typography>
  );
};

PublishedInstructionLink.propTypes = {
  data: PropTypes.object.isRequired,
  visible: PropTypes.bool
};

export default PublishedInstructionLink;
